import { DomEditor, IDomEditor, SlateElement } from '@wangeditor/editor'
import katex from 'katex'
import { h, VNode } from 'snabbdom'

import { FormulaElement } from './types'

function renderFormula(
  elem: SlateElement,
  children: VNode[] | null,
  editor: IDomEditor
): VNode {
  // 当前节点是否选中
  const selected = DomEditor.isNodeSelected(editor, elem)

  // 构建 formula vnode
  const { value = '' } = elem as FormulaElement

  var html = katex.renderToString(value, {
    output: 'mathml',
    throwOnError: false,
  })

  const formulaVnode = h('w-e-formula-card', {
    dataset: { value },
    // innerHTML: html,
  })

  // 构建容器 vnode
  const containerVnode = h(
    'span',
    {
      props: {
        contentEditable: false, // 不可编辑
      },
      style: {
        display: 'inline-block', // inline
        marginLeft: '3px',
        marginRight: '3px',
        border: selected // 选中/不选中，样式不一样
          ? '2px solid var(--w-e-textarea-selected-border-color)' // wangEditor 提供了 css var https://www.wangeditor.com/v5/theme.html
          : '2px solid transparent',
        borderRadius: '3px',
        padding: '3px 3px',
      },
    },
    [formulaVnode]
  )

  return containerVnode
}

const conf = {
  type: 'formula', // 节点 type ，重要！！！
  renderElem: renderFormula,
}

export default conf
